var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.loading
    ? _c("ProgressCircular")
    : _c(
        "form",
        {
          attrs: { novalidate: "", disabled: _vm.disabled },
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.submit()
            },
          },
        },
        [
          _c(
            "v-row",
            { attrs: { "no-gutters": "" } },
            [
              _c(
                "v-col",
                { attrs: { cols: "8" } },
                [
                  _c(
                    "v-card",
                    {
                      attrs: {
                        "max-width": "1200",
                        flat: "",
                        color: "transparent",
                      },
                    },
                    [
                      _c(
                        "v-card-title",
                        { staticClass: "mb-10" },
                        [
                          _c("FormHeader", {
                            attrs: {
                              loading: _vm.loading,
                              disabled: _vm.disabled,
                              link: "page-streams",
                              title: _vm.getTitle
                                ? `Редактировать ${_vm.getTitle}`
                                : `Добавить трансляцию`,
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-card-text",
                        [
                          _c(
                            "PageContent",
                            { attrs: { height: "85" } },
                            [
                              _c(
                                "v-container",
                                [
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c(
                                            "span",
                                            [
                                              _vm._v("Имя * ("),
                                              _c("TranslationIcon"),
                                              _vm._v(")"),
                                            ],
                                            1
                                          ),
                                          _c("v-text-field", {
                                            attrs: {
                                              outlined: "",
                                              id: "name",
                                              autofocus: !_vm.fields.title,
                                              "error-messages":
                                                _vm.validationErrors.title,
                                              disabled: _vm.disabled,
                                              loading: _vm.loading,
                                            },
                                            model: {
                                              value: _vm.fields.title,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.fields,
                                                  "title",
                                                  $$v
                                                )
                                              },
                                              expression: "fields.title",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "6" } },
                                        [
                                          _c("v-switch", {
                                            attrs: {
                                              outlined: "",
                                              label: "Активен",
                                              disabled: _vm.disabled,
                                              loading: _vm.loading,
                                            },
                                            model: {
                                              value: _vm.fields.isActive,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.fields,
                                                  "isActive",
                                                  $$v
                                                )
                                              },
                                              expression: "fields.isActive",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "6" } },
                                        [
                                          _c("v-switch", {
                                            attrs: {
                                              outlined: "",
                                              label: "Онлайн",
                                              disabled: _vm.disabled,
                                              loading: _vm.loading,
                                            },
                                            model: {
                                              value: _vm.fields.isOnline,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.fields,
                                                  "isOnline",
                                                  $$v
                                                )
                                              },
                                              expression: "fields.isOnline",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c("MediaFilePicker", {
                                    attrs: {
                                      label: "Изображение",
                                      multiple: false,
                                      "file-type":
                                        _vm.$options.mediaTypesByKeys.IMAGE,
                                      value: _vm.fields.thumbnailId,
                                    },
                                    on: {
                                      change: function ($event) {
                                        _vm.fields.thumbnailId = $event
                                      },
                                    },
                                  }),
                                  _vm.$apollo.queries.streamsExternal.loading
                                    ? _c("v-row", [_c("ProgressCircular")], 1)
                                    : [
                                        _c(
                                          "v-row",
                                          [
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "6" } },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    "Выберите поток камеры"
                                                  ),
                                                ]),
                                                _c("v-select", {
                                                  attrs: {
                                                    outlined: "",
                                                    "no-data-text":
                                                      "Список пуст",
                                                    "item-value": "id",
                                                    "item-text": "name",
                                                    clearable: "",
                                                    "disable-lookup": "",
                                                    loading:
                                                      _vm.loading ||
                                                      _vm.$apollo.queries
                                                        .streamsExternal
                                                        .loading,
                                                    disabled: _vm.disabled,
                                                    value: _vm.fields.streamId,
                                                    items: _vm.streamsExternal,
                                                  },
                                                  on: {
                                                    input: function ($event) {
                                                      _vm.fields.streamId =
                                                        $event
                                                    },
                                                  },
                                                  scopedSlots: _vm._u([
                                                    {
                                                      key: "item",
                                                      fn: function ({ item }) {
                                                        return [
                                                          _c(
                                                            "v-list",
                                                            [
                                                              _c(
                                                                "v-list-item",
                                                                [
                                                                  _c(
                                                                    "v-subheader",
                                                                    [
                                                                      _vm._v(
                                                                        "Имя: " +
                                                                          _vm._s(
                                                                            item.name
                                                                          )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c(
                                                                    "v-list-item-group",
                                                                    [
                                                                      _c(
                                                                        "v-list-item-content",
                                                                        [
                                                                          _c(
                                                                            "v-list-item-subtitle",
                                                                            [
                                                                              _vm._v(
                                                                                "Город: " +
                                                                                  _vm._s(
                                                                                    item.districtName
                                                                                  )
                                                                              ),
                                                                            ]
                                                                          ),
                                                                          _c(
                                                                            "v-list-item-subtitle",
                                                                            [
                                                                              _vm._v(
                                                                                "Тип: " +
                                                                                  _vm._s(
                                                                                    item.cameraTypeName
                                                                                  )
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ],
                                                                        1
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                  ]),
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm.fields.streamId
                                          ? _c(
                                              "v-row",
                                              [
                                                _c(
                                                  "v-col",
                                                  { attrs: { cols: "12" } },
                                                  [
                                                    _c("span", [
                                                      _vm._v("Расположение"),
                                                    ]),
                                                    _c("LocationAutocomplete", {
                                                      ref: "LocationAutocomplete",
                                                      attrs: {
                                                        address: _vm.getAddress,
                                                        readonly: "",
                                                        loading:
                                                          _vm.loading ||
                                                          _vm.disabled,
                                                      },
                                                      on: {
                                                        "set-location":
                                                          _vm.setLocation,
                                                        "update-location-part":
                                                          _vm.updateLocation,
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ],
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "4" } },
                [
                  _c("ManageSidePanel", {
                    attrs: {
                      isShowSortOrder: "",
                      isNew: _vm.isNew,
                      "created-at": _vm.getCreatedAt,
                      "updated-at": _vm.getUpdatedAt,
                      language: _vm.language,
                      "is-submit-disabled": _vm.disabled,
                      "is-loading": _vm.loading,
                      translations: _vm.fields.translations,
                      "entity-id": _vm.getId,
                      "entity-type": "stream",
                      sortOrder: _vm.fields.sortOrder,
                    },
                    on: {
                      delete: function ($event) {
                        return _vm.$emit("delete-stream")
                      },
                      cancel: function ($event) {
                        return _vm.$router.push({ name: "page-streams" })
                      },
                      "update-translations": function ($event) {
                        return Object.assign(_vm.fields.translations, $event)
                      },
                      "language-update": function ($event) {
                        return _vm.$emit("language-update", $event)
                      },
                      "update-sort-order": function ($event) {
                        _vm.fields.sortOrder = Number($event)
                      },
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "body",
                        fn: function () {
                          return [
                            _c(
                              "v-col",
                              { attrs: { cols: "12" } },
                              [
                                _c("CityPicker", {
                                  attrs: { title: "Город" },
                                  model: {
                                    value: _vm.fields.cityId,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.fields, "cityId", $$v)
                                    },
                                    expression: "fields.cityId",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              { attrs: { cols: "12" } },
                              [
                                _c("PlacePicker", {
                                  attrs: { title: "Место" },
                                  model: {
                                    value: _vm.fields.placeId,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.fields, "placeId", $$v)
                                    },
                                    expression: "fields.placeId",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }